import apiClient from "./apiClient";
import { parseApiDate } from "../utils/date";

const formatNotificationTimestamp = (value) => {
  if (!value) {
    return "";
  }

  const date = parseApiDate(value);
  if (!date || Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("it-IT", {
    timeZone: "Europe/Rome",
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

const list = async () => {
  const response = await apiClient.get("/notifications");
  const notifications = Array.isArray(response?.data?.items) ? response.data.items : [];

  return notifications.map((notification) => ({
    ...notification,
    read: Boolean(notification.read),
    timestampLabel: formatNotificationTimestamp(notification.timestamp),
  }));
};

const markAsRead = async (notificationIds = []) => {
  const ids = notificationIds.filter(Boolean);
  if (!ids.length) {
    return;
  }
  await apiClient.post("/notifications/read", { ids });
};

const markAllAsRead = async (notifications = []) => {
  const ids = notifications.map((item) => item.id).filter(Boolean);
  await markAsRead(ids);
};

const getUnreadCount = (notifications = []) =>
  notifications.filter((item) => !item.read).length;

const NotificationService = {
  list,
  markAsRead,
  markAllAsRead,
  getUnreadCount,
};

export default NotificationService;

